/** 通知直达市检记录；普通内部同事只需被指派即可打开本记录，不暴露整个分包商工作台。 */
import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useApp } from "../context/AppContext";
import ScheduleInspectionDetail from "../components/subcontract/ScheduleInspectionDetail";

export default function InspectionSchedule() {
  const { id } = useParams(), navigate = useNavigate();
  const { api, lang, user } = useApp();
  return <ScheduleInspectionDetail id={id} api={api} zh={lang === "zh"} onClose={() => navigate(user?.role === "subcontractor" ? "/portal/schedule" : "/reminders")} />;
}
